<template>
	<div class="layout">
		<div class="lauout_top">
			<div class="top_bar">
				<div class="top_bar_wrap">
					<div class="left">
						<div class="right_item" @click="$router.push({path:'/pdfPlay',query:{
							id:1
						}})" style="margin-right: 20px;">使用手册</div>
						<!-- 三全育人平台 -->
					</div>
					<div class="center">
                       <img src="../../assets/zhuozi/zhuozi_logo.png" alt="">
					</div>
					<div class="right">
						<div class="right_item" @click="$router.push({path:'/search'})" style="margin-right: 20px;">资源检索</div>
						<div @click="$router.push({path:'/admin'})" class="right_item">前往后台</div>
					</div>
				
				</div>
		   </div>
		<!-- 导航 -->
		<div class="nav">
			<div class="nav_wrap">
				<router-link :to="{path:'/?index=1'}" class="nav_item"  >
				<div class="nav_item_box"  >
					<div class="nav_item_border" :class="{active_title:selectNav==1}">
						&nbsp;首页&nbsp;
					</div>
				</div>
				</router-link>
				<div @click="goSpeaial(11)" class="nav_item"  >
					<div class="nav_item_box">
						<div class="nav_item_border" :class="{active_title:selectNav==2}">
							&nbsp;知识图谱&nbsp;
						</div>
				    </div>
				</div>
				<div  @click="goSpeaial(12)"  class="nav_item"  >
					<div class="nav_item_box">
						<div class="nav_item_border" :class="{active_title:selectNav==3}">
							&nbsp;课程思政&nbsp;
						</div>
				    </div>
				</div>
				<div  class="nav_item top_item5"  @click="goSpeaial(6)" >
					<div class="nav_item_box">
						<div class="nav_item_border" :class="{active_title:selectNav==4}">
							&nbsp;思政课程&nbsp;
						</div>
				    </div>
					<!-- <div class="szflzz">
						<div class="szflzz_item"  @click="goSpeaial(6)">
							中职版
						</div>
						<div class="szflzz_item" @click="goSpeaial(7)" style="border-bottom: none;">
							大学版
						</div>
					</div> -->
				</div>
				<div class="nav_item top_item5"  >
					<div class="nav_item_box" style="border-right: none;">
						<div class="nav_item_border" :class="{active_title:selectNav==5}">
							&nbsp;学习园地&nbsp;
						</div>
				    </div>
					<div class="szflzz">
						<div class="szflzz_item" @click="goNav('/djxx','dyjy')">
							党员教育
						</div>
						<div class="szflzz_item"  @click="goNav('/tszt','tszt')">
							特色专题
						</div>
						<div class="szflzz_item" @click="goSpeaial(3)">
							德育专题
						</div>
						<!-- @click="goNav('/sjgc','sjgc')" -->
						<div class="szflzz_item"  @click="goSpeaial(14)" >
							三进工程
						</div>
						<div class="szflzz_item"  @click="$router.push({path:'/pdfPlay2',query:{
							id:2
						}})"   style="border-bottom: none;">
							校本教材
						</div>
					</div>
				</div>
				<div class="top_nav_Center">
                      <img src="../../assets/zhuozi/zhuozi_school_name.png" alt="">
				</div>
				<router-link target="_blank" :to="{path:'/hsqj?index=6'}" class="nav_item"  >
					<div class="nav_item_box">
						<div class="nav_item_border" :class="{active_title:selectNav==6}">
							&nbsp;红色全景&nbsp;
						</div>
				    </div>
				</router-link>
				<div  class="nav_item top_item5"  >
					<div class="nav_item_box">
						<div class="nav_item_border" :class="{active_title:selectNav==7}">
							&nbsp;培训专题&nbsp;
						</div>
						<div class="szflzz">
							<div class="szflzz_item" @click="goNav('/ztpx','ztpx')">
								党建培训
							</div>
							<div class="szflzz_item" @click="goNav('/szpx','szpx')" style="border-bottom: none;">
								师资培训
							</div>
					    </div>
				    </div>
				</div>
				<div   class="nav_item"  >
					<div class="nav_item_box">
						<div @click="goSpeaial(9)" class="nav_item_border" :class="{active_title:selectNav==8}">
							&nbsp;名师工作室&nbsp;
						</div>
				    </div>
				</div>
				<div  :to="{path:'/tszt?index=9'}" class="nav_item top_item5"  >
					<div class="nav_item_box">
						<div style="width:100px;" class="nav_item_border" :class="{active_title:selectNav==9}">
							&nbsp; 党群建设 &nbsp;
						</div>
						<div class="szflzz">
							<div class="szflzz_item" @click="goNav('/dwgk','dwgk')">
								党务公开
							</div>
							<div class="szflzz_item" @click="goNav('/shyk','shyk')">
								三会一课
							</div>
							<router-link target="_blank" :to="{path:'/djxc'}"    class="szflzz_item" style="text-decoration: none; display: block; color: #fff;">
								党建大数据
							</router-link>
							<div class="szflzz_item" @click="goNav('/djgj','djgj')" style="border-bottom: none;">
								党建共建
							</div>
					   </div>
				    </div>
				</div>
				<router-link :to="{path:'/bxzy?index=10'}"  class="nav_item"   >
					<div class="nav_item_box" style="border-right: none;">
						<div class="nav_item_border" :class="{active_title:selectNav==10}">
							&nbsp;本校资源&nbsp;
						</div>
				    </div>
				</router-link>
				
				
			</div>
		</div>
		</div>
		<!-- 显示区域 -->
		<div class="showCenter">
			<!-- :key="Math.random()" -->
			<router-view :key="routerKey" @highLight="changeNav" ></router-view>
		</div>
		<div class="footer">
			<div class="footer_wrap">
				<div class="logo">
					<img src="../../assets/zhuozi/zhuozi_footer.png" >
				</div>
				<div class="bottom">
					<span>技术支持：人民视讯 </span>
					<span>服务邮箱：videokf@peoplevideo.cn</span>
					<span>电话： 4009019665</span>
					<span>地址：北京市朝阳区新源南路1-3号平安国际金融中心A座12层</span>
				</div>
				
			</div>
			
		</div>
	</div>
</template>

<script>
     import {user } from '@/axios'
	// import applyBox from '@/components/apply.vue';
	import { Message } from 'element-ui'
	export default {
		data(){
			return{
				key:Math.random(),
				selectNav:this.$route.query.index,
				applyLogin:false,
				hidden:0,
				hidden2:0,
				inputValue:'',
				routerKey:'',
				centerDialogVisible2:false,
				// 登录
				ruleForm2: {
                            username:'',
                            password: '',
                 },
				 rules2: {
                            username:[
                            { required: true, message: '请输入账号', trigger: 'blur' },
                            ],
                            password: [
                               { required: true, message: '密码不能为空', trigger: 'blur' },
                               { min:6, max: 20, message: '密码长度在6到 20 个字符', trigger: 'blur' }
                            ],
                }
			}
		},
		// components: {
		// 	applyBox
		// },
		methods:{ 
            goNav(path,type){
			
				this.$router.push({
					path:path,
					query:{
						type:type
					}
					
				})
			},
		    // 专题
			goSpeaial(index){
				this.routerKey=Math.random()
				this.$router.push({
					path:'/special',
					query:{
						id:index
					}
				})
				// this.$router.go(0);
			},

			// 当鼠标移入时控制hidden的值控制显示与隐藏
			enterTitle(index){
			
			this.hidden=index
		     },
			goPage(){
				
            
			},
			// 当鼠标移入时控制hidden的值控制显示与隐藏
			changeHidden(index){
               this.hidden=index
			},
			changeHidden2(index){
               this.hidden2=index
			},
			// 接收子元素传来高亮导航 并跳转详情页
			changeNav(index,bsid,id,type){
				document.getElementsByClassName("layout").scrollTop = 0;
				var that = this;
				that.selectNav = index;
				
			},
			// 申请入驻窗口打开
			applyShow(){
				var that = this;
				that.applyLogin = true;
			},
			// 申请入驻窗口关闭
			closeWin(){
				var that = this;
				that.applyLogin = false;
			},
			// 点击搜索按钮跳转至搜索详情页
			goSearch(){
				let that=this
				 if (that.inputValue.trim()!='') {
					this.$router.push({
					path:'/djxx',
					query:{
						type:'search',
						keys:that.inputValue,
						index:2
					}
				 })
				//  清空input框
				this.inputValue=''
				}else{
					Message({
					type:"error",
					message:"搜索内容不能为空"
				})
				}
			},
		},
		mounted () {
			
		}
	}
</script>

<style lang="scss">
	@import '@/common/index.scss';
	.layout{
		width: 100%;
		height: 100%;
		.lauout_top{
			width: 100%;
			height: 178px;
			background-image: url(../../assets/zhuozi/loaout_top.png);
			background-size: 100% 100%;
			background-repeat: no-repeat;
		}
		.top_bar{
			height: 125px;
			width: 100%;
			&_wrap{
				width: $indexWidth;
				height: 100%;
				margin: auto;
				display: flex;
				align-items: center;
				justify-content: space-between;
				.left{
					height: 34px;
					width: 158.41px;
					line-height: 34px;
					font-family: PingFangSC-Medium;
					font-size: 24px;
					font-weight: normal;
					line-height: normal;
					text-align: justify; 
					letter-spacing: 0.1em;
					color: #FFFFFF;
					.right_item{
                    height: 100%;
					width: 72px;
					background-color: #FF9D57;
					border-radius: 16px;
					color: #fff;
					font-size: 14px;
					line-height: 32px;
					text-align: center;
					cursor: pointer;
				  }
			     	}
				.center{
					width: 656px;
					height: 133px;
					img{
						width: 100%;
						height: 100%;
					}
				}
				.right{
				  width: 158px;
				  display: flex;
				  justify-content: right;
				  align-items: center;
				  height: 32px;
				  .right_item{
                    height: 100%;
					width: 72px;
					background-color: #FF9D57;
					border-radius: 16px;
					color: #fff;
					font-size: 14px;
					line-height: 32px;
					text-align: center;
				  }

				}
			}
			

		}
		// 导航
		.nav{
			width: 100%;
			height: 51px;
			line-height: 51px;
			font-size: 18px;
			&_wrap{
				position: relative;
				margin: auto;
				display: flex;
				align-items: center;
				justify-content: space-between;
				height: 100%;
				font-size: $indexSize;
				width: $indexWidth;
				.nav_item{
					position: relative;
					display: flex;
					align-items: center;
					cursor: pointer;
					text-align: center;
					color: #fff;
					text-decoration: none;
					font-size: 16px;
					box-sizing: border-box;
					width: 100px;
					height: 51px;
					justify-content: center;
					.nav_item_box{
                        height: 16px;
						width: 100%;
						border-right: 1px solid #E49395;
						display: flex;
						align-items: center;
						justify-content: center;
						.nav_item_border{
						height: 51px;
						line-height: 51px;
						box-sizing: border-box;
						
					    }
						.active_title{
							border-bottom: 2px solid #fff;
						}
					}
					
					
				}
				.top_item5{
						position: relative;
				}
				
				.top_item5:hover .szflzz_item{
					height: 51px;	
					border-bottom: 1px solid #AA1014;
					a{
						text-decoration: none;
						color: #fff;
					}
				}
				.szflzz{
					position: absolute;
					top:51px;
					overflow: hidden;
					width: 100%;
					background-color: #C6262A;
					z-index: 99;
					box-sizing: border-box;
					padding: 0 10px;
					.szflzz_item{
						width: 100%;
						height: 0px;
						transition:height .4s;
						box-sizing: border-box;
						
					}

				}
				.top_nav_Center{
					
					width:210px;
					height: 100%;
					display: flex;
					justify-content: center;
					position: relative;
					img{
						position: absolute;
						bottom: 5px;
						left: 50%;
						transform: translateX(-50%);
						display: block;
						width:160px;
						height: 55px;

					}
				}
				.selectNav{
					border-bottom: 4px solid #fff;
				}
			}
		}
		.footer{
			margin-top: 60px;
			width: 100%;
			height:170px;
			color: #fff;
			background: #CB272B;
			&_wrap{
				width: $indexWidth;
				margin: auto;
				display: flex;
				height: 100%;
				align-items: center;
				position: relative;
				flex-direction: column;
				justify-content: space-between;
				align-items: center;
				.logo{
					height: 52px;
				    width: 368px;
					margin-top: 33px;
					img{
						height: 100%;
						width: 100%;
					}
				}
			
			    .bottom{
					
					width: 100%;
					height:20px;
					font-family: MicrosoftYaHei;
					font-size: 14px;
					font-weight: normal;
					color: #FFFFFF;
					display: flex;
					justify-content: center;
					margin-bottom: 39px;
					span{
						margin-left: 20px;
						margin-right: 20px;
					}
					
				}
			
				
			}
			
		}
		.showCenter{
			width: 100%;
			font-size: 0;
			margin: auto;
			min-height: 400px;
		}
	}

</style>
